import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API;
class KioskMetaService {
  // Get Kiosk meta language list
  async getLanguages(filter = "") {
    const response = await axios.get(
      API_URL + "app-setting/kiosk-language" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Tag Related APIs
  // Get Kiosk meta tag list
  async getTags(filter = "") {
    const response = await axios.get(
      API_URL + "app-setting/kiosk-labal-tag" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Update Kiosk meta tag
  async updateTag(id, data) {
    const response = await axios.patch(
      API_URL + "app-setting/kiosk-labal-tag/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete Kiosk meta tag
  async deleteTag(id) {
    const response = await axios.delete(
      API_URL + "app-setting/kiosk-labal-tag/" + id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // Text Label Related APIs
  // Get Kiosk meta text label list
  async getTextLabels(filter = "") {
    const response = await axios.get(
      API_URL + "app-setting/kiosk-text-meta" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Update Kiosk meta text label list
  async updateTextLabel(id, data) {
    const response = await axios.patch(
      API_URL + "app-setting/kiosk-text-meta/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Video Related APIs
  // Get Kiosk meta video list
  async getVideos(filter = "") {
    const response = await axios.get(
      API_URL + "app-setting/kiosk-video-meta" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Update Kiosk meta video list
  async updateVideo(id, data) {
    const response = await axios.patch(
      API_URL + "app-setting/kiosk-video-meta/" + id,
      data,
      {
        headers: authHeaderWithMultipartData(),
      }
    );
    return response.data;
  }
}
export default new KioskMetaService();
